export const HttpCode = {
  NoAuthentication: 401,
  NotValidToken: 403,
};
